import * as R from 'ramda';

import { getFilteredItems } from 'components/Pages/Admin/GuestPortal/Flights/utils';
import axios from 'utils/axios';

import { accountIdSelector } from '../../user/selectors';
import {
  setRelocationsDataAction,
  initializRelocationsAction,
  createRelocationsItem,
  removeAllRelocationsAction,
} from '../index';
import { itineraryRelocationsSelector } from './selectors';

export const getAirlinesThunk = (id, query) => async (dispatch, getStore) => {
  const queryString = query ? `?q=${query}` : '';
  const accountId = accountIdSelector(getStore());
  const data = await axios
    .get(`/acc/${accountId}/guest_portals/${id}/air_data/airlines${queryString}`)
    .then(({ data = {} }) => data);
  return data;
};

export const getAirportsThunk = (id, query) => async (dispatch, getStore) => {
  const queryString = query ? `?q=${query}` : '';
  const accountId = accountIdSelector(getStore());
  const data = await axios
    .get(`/acc/${accountId}/guest_portals/${id}/air_data/airports${queryString}`)
    .then(({ data = {} }) => data);
  return data;
};

export const getScheduledFlightsByFlightNumberThunk = (params) => async (dispatch, getStore) => {
  const { itemId, airlineFsCode, flightNumber, departureDate } = params;
  const accountId = accountIdSelector(getStore());
  const data = await axios
    .get(
      `/acc/${accountId}/guest_portals/${itemId}/air_data/scheduled_flights_by_flight_number?airline_fs_code=${airlineFsCode}&flight_number=${flightNumber}&departure_date=${departureDate}`,
    )
    .then(({ data = {} }) => data);
  return data;
};

export const getScheduledFlightsByRouteThunk = (params) => async (dispatch, getStore) => {
  const { itemId, departureAirportFsCode, arrivalAirportFsCode, departureDate } = params;
  const accountId = accountIdSelector(getStore());
  const data = await axios
    .get(
      `/acc/${accountId}/guest_portals/${itemId}/air_data/scheduled_flights_by_route?departure_airport_fs_code=${departureAirportFsCode}&arrival_airport_fs_code=${arrivalAirportFsCode}&departure_date=${departureDate}`,
    )
    .then(({ data = {} }) => data);
  return data;
};

export const updateRelocationsThunk = (index, data) => async (dispatch, getStore) => {
  const relocations = itineraryRelocationsSelector(getStore());

  const updateItem = () => data;
  const newData = R.adjust(Number(index), updateItem, relocations);

  dispatch(setRelocationsDataAction(newData));
};

export const resetEmptyRelocationsThunk = () => async (dispatch, getStore) => {
  const relocations = itineraryRelocationsSelector(getStore());

  const newData = getFilteredItems(relocations);

  dispatch(setRelocationsDataAction(newData));
};

export const initializeRelocationsThunk =
  ({ createItemIfEmpty = false } = {}) =>
  (dispatch, getStore) => {
    const relocations = itineraryRelocationsSelector(getStore());

    dispatch(
      initializRelocationsAction(createItemIfEmpty && R.isEmpty(relocations) ? [createRelocationsItem()] : relocations),
    );
  };

export const removeAllRelocationsThunk = () => async (dispatch, getStore) => {
  dispatch(removeAllRelocationsAction());
  return itineraryRelocationsSelector(getStore()).filter((flight) => flight.createdAt);
};
